import React, { useState, useEffect } from 'react';

import { 

  Bars3Icon,
 
} from '@heroicons/react/24/outline';

import './Header.css';


const  ToggleMenu = ({toggleMobileMenu}: {toggleMobileMenu: () => void}) => {
  const [hasAnimated, setHasAnimated] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setHasAnimated(true);
    }, 100); // Small delay for better effect
    return () => clearTimeout(timer);
  }, []);

  return (
    <button 
      className={`mobile-menu-button ${hasAnimated ? 'animated' : ''}`}
      onClick={toggleMobileMenu}
      aria-label="Toggle mobile menu"
    >
      <Bars3Icon className="menu-icon" />
    </button>
  );
};

export default ToggleMenu;
